import jQuery from 'jquery';
import React from 'react';

import Configurator from './Configurator.jsx';
import styles from './UermConfigurator.styl';

import imgKet from './images/uerm/IND-KET-1.jpg';
import imgKetTran from './images/uerm/IND-KET-1-T.jpg';
import imgKetLight from './images/uerm/IND-KET-1-L.jpg';
import imgKomp from './images/uerm/IND-KOMP.jpg';
import imgKompLight100 from './images/uerm/IND-KOMP-100-200-L.jpg';
import imgKompLight200 from './images/uerm/IND-KOMP-200-400-L.jpg';
import imgKompLight400 from './images/uerm/IND-KOMP-400-600-L.jpg';
import imgKss from './images/uerm/IND-KSS-1.jpg';
import imgKssTran from './images/uerm/IND-KSS-1-T.jpg';
import imgKssLight from './images/uerm/IND-KSS-1-L.jpg';
import imgKetKssLight600 from './images/uerm/IND-KET-KCC-1-0600-L.jpg';
import imgKetKssLight1200 from './images/uerm/IND-KET-KCC-1-1200-L.jpg';
import imgKetKssLight1800 from './images/uerm/IND-KET-KCC-1-1800-L.jpg';
import imgYaur from './images/uerm/IND-YAUR-3-12.jpg';
import imgYaurNew from './images/uerm/YAUR-380-300-31.jpg';
import imgYaurLight from './images/uerm/IND-YAUR-3-12-L.jpg';
import imgYaurLightNew from './images/uerm/YAUR-380-300-31-L.jpg';
import imgMkm from './images/uerm/IND-MKM51-YAU-290-300.jpg';
import imgMkmLight from './images/uerm/MKM51-YAU-290-300-L.jpg';


/**
 * Конфигуратор УЭРМ
 */
class UermConfigurator extends Configurator
{
	constructor(props) {
		super(props);

		this.state = jQuery.extend({}, this.state, {

			uermList: [
				{
					height: 0,
					kvCnt: 0,
					yaurType: 'mp',
					ket: 0,
					kss: 0,
					ketTran: 0,
					kssTran: 0,
					count: 0
				}
			],

			uermListLight: [
				{
					height: 0,
					kvCnt: 0,
					yaurType: 'mp',
					ket: 0,
					kss: 0,
					count: 0
				}
			],

			specList: [],
			specListLight: [],

			curAcc: null,
			showScheme: false,
			uermType: ''

		});

		this.onAddUerm        = this.onAddUerm.bind(this);
		this.onDeleteUerm     = this.onDeleteUerm.bind(this);
		this.onSpecAdd        = this.onSpecAdd.bind(this);
		this.onUermPropChange = this.onUermPropChange.bind(this);
		this.onBtnExcelClick  = this.onBtnExcelClick.bind(this);
		this.onSpecRowClick   = this.onSpecRowClick.bind(this);
		this.onShowScheme     = this.onShowScheme.bind(this);
		this.onCloseScheme    = this.onCloseScheme.bind(this);
		this.onChangeUermType = this.onChangeUermType.bind(this);
		this.on3DDownload     = this.on3DDownload.bind(this);
		this.onPDFDownload    = this.onPDFDownload.bind(this);
	}

	getType() {
		return 'uerm';
	}

	getCustomStyles() {
		return styles;
	}

	onShowScheme() {
		this.setState({
			showScheme: true
		});
	}

	onCloseScheme() {
		this.setState({
			showScheme: false
		});
	}
	doAddToCart(items){
		const goods = JSON.stringify(
			{
				category: items.map((i,id) => {
						return {
							name: `УЭРМ ${id+1}`,
							cnt: i.count,
							products: i.acc.map(i => (
								{
									cnt: i.count || 1,
									art: i.article,
									name: i.name,
								}
							))
						}
				}
				)
			}
		)
		console.log(goods);
		// Отправка JSON в ipro
		window.top.postMessage(goods, '*')

	}

	onAddUerm() {
		if (this.isUermLight())
		{
			this.setState({
				uermListLight: [
					...this.state.uermListLight,
					{
						height: 0,
						kvCnt: 0,
						yaurType: 'din',
						ket: 0,
						kss: 0,
						count: 0
					}
				]
			});
		}
		else
		{
			this.setState({
				uermList: [
					...this.state.uermList,
					{
						height: 0,
						kvCnt: 0,
						yaurType: 'din',
						ket: 0,
						kss: 0,
						count: 0
					}
				]
			});
		}

	}

	onChangeUermType(event) {
		this.setState({
			uermType: event.target.value,
			curAcc: null
		});
	}

	isUermLight() {
		return this.state.uermType === 'light';
	}

	onDeleteUerm(num) {
		let uermList = this.isUermLight() ? this.state.uermListLight.slice() : this.state.uermList.slice();
		uermList.splice(num - 1, 1);

		let specList = this.isUermLight() ? this.state.specListLight.slice() : this.state.specList.slice();
		specList.splice(num - 1, 1);

		if (this.isUermLight())
		{
			this.setState({
				uermListLight: uermList,
				specListLight: specList
			});
		}
		else
		{
			this.setState({
				uermList,
				specList
			});
		}
	}

	onSpecAdd(num) {
		const isUermLight = this.isUermLight();

		let uerm = jQuery.extend({}, isUermLight ? this.state.uermListLight.slice(num - 1, num)[0] : this.state.uermList.slice(num - 1, num)[0]);

		if (uerm.height <= 0)
		{
			alert('Не выбрана высота УЭРМ');
			return;
		}

		if (uerm.kvCnt <= 0)
		{
			alert('Не выбрано количество квартир');
			return;
		}

		if (uerm.count <= 0)
		{
			alert('Не выбрано количество УЭРМ');
			return;
		}


		uerm.count = uerm.count <= 0 ? 1 : uerm.count;
		uerm.acc   = [];


		// Добавление в спискок корпуса
		if (uerm.yaurType === 'din') {
			uerm.acc.push({
				article: isUermLight ? 'MKM51-YAU-290-300-L' : 'IND-MKM51-YAU-290-300' ,
				name: 'Корпус металлический ЯУ-290-300 36 УХЛ3 IP31',
				count: uerm.kvCnt * uerm.count,
				desc: 'Предназначен для учета и распределения электроэнергии. Монтаж счетчика производится на DIN-рейку.',
				img: styles.imgMkm,
				imgSrc: isUermLight ? imgMkmLight : imgMkm
			});
		}

		if(uerm.yaurType === 'mp') {
				uerm.acc.push({
					article: isUermLight ? 'IND-YAUR-3-12-L' : 'IND-YAUR-3-12',
					name: isUermLight ? 'Ящик учетно-распределительный ЯУР-3/12 LIGHT' : 'Ящик учетно-распределительный ЯУР-3/12',
					count: uerm.kvCnt * uerm.count,
					desc: 'Предназначен для учета и распределения электроэнергии. Монтаж счетчика производится на монтажную плату.',
					img: isUermLight ? styles.imgYaurLight : styles.imgYaur,
					imgSrc: isUermLight ? imgYaurLight : imgYaur
				});
			}
		if(uerm.yaurType === 'yhlz') {
				uerm.acc.push({
					article: isUermLight ? 'YAUR-380-300-31-L' : 'YAUR-380-300-31',
					name: isUermLight ? 'Ящик учетно-распределительный ЯУР-380-300 LIGHT IEK' : 'Ящик учетно-распределительный ЯУР-380-300 УХЛ3 IP31 IEK',
					count: uerm.kvCnt * uerm.count,
					desc: 'Предназначен для учета и распределения электроэнергии. Монтаж счетчика производится на монтажную плату.',
					img: isUermLight ? styles.imgYaurLightNew : styles.imgYaurNew,
					imgSrc: isUermLight ? imgYaurLightNew : imgYaurNew
				});
			}


		// добавение в список Короб КЭТ
		if (parseInt(uerm.ket) > 0)
		{
			uerm.acc.push({
				article: isUermLight ? 'IND-KET-1-L' : 'IND-KET-1',
				name: isUermLight ? 'Короб КЭТ LIGHT' : 'Короб КЭТ',
				count: uerm.ket * uerm.count,
				desc: 'Составной элемент УЭРМ, в котором располагается силовые кабели.',
				img: isUermLight ? styles.imgKetLight : styles.imgKet,
				imgSrc: isUermLight ? imgKetLight : imgKet
			});
		}

		// добавение в список Короб КСС
		if (parseInt(uerm.kss) > 0)
		{
			uerm.acc.push({
				article: isUermLight ? 'IND-KSS-1-L' : 'IND-KSS-1',
				name: isUermLight ? 'Короб КCC LIGHT' : 'Короб КCC',
				count: uerm.kss * uerm.count,
				desc: 'Для размещения устройств слаботочных сетей (теле- и радиосетей, телефонных линий, домофонов) и оборудования автоматической системы контроля и учета электропотребления (АСКУЭ).',
				img: isUermLight ? styles.imgKssLight : styles.imgKss,
				imgSrc: isUermLight ? imgKssLight : imgKss
			});
		}

		// добавение в список Короб КЭТ Транзит
		if (parseInt(uerm.ketTran) > 0)
		{
			uerm.acc.push({
				article:'IND-KET-1-T',
				name: 'Короб КЭТ транзитный',
				count: uerm.ketTran * uerm.count,
				desc: 'Составной элемент УЭРМ, в котором располагается силовое оборудование и кабели.',
				img: styles.imgKet,
				imgSrc: imgKetTran
			});
		}

		// добавение в список Короб КСС Транзит
		if (parseInt(uerm.kssTran) > 0)
		{
			uerm.acc.push({
				article: 'IND-KSS-1-T',
				name: 'Короб КCC транзитный',
				count: uerm.kssTran * uerm.count,
				desc: 'Для размещения устройств слаботочных сетей (теле- и радиосетей, телефонных линий, домофонов) и оборудования автоматической системы контроля и учета электропотребления (АСКУЭ).',
				img: styles.imgKss,
				imgSrc: imgKssTran
			});
		}

		// добавление в список Компенсатор высоты
		if (parseInt(uerm.ket) > 0 || parseInt(uerm.kss) > 0)
		{
			const count = ((parseInt(uerm.ket) + parseInt(uerm.kss)) * uerm.count) / 2 ;
			const countTran = ((parseInt(uerm.ketTran) + parseInt(uerm.kssTran)) * uerm.count) / 2;

			if (!isUermLight)
			{
				uerm.acc.push({
					article: `IND-KOMP-${uerm.height}-1`,
					name: `Компенсатор высоты для УЭРМ-Х-${uerm.height} (к-т 2шт.)`,
					count: Math.ceil(count +  countTran),
					desc: 'Составная часть для регулирования УЭРМ по высоте.',
					img: styles.imgKomp,
					imgSrc: imgKomp
				});
			}

			if (isUermLight)
			{
				if (['2500-2600', '3100-3200', '3700-3800'].indexOf(uerm.height.toString()) >= 0)
				{
					uerm.acc.push({
						article: 'IND-KOMP-100-200-1-L',
						name: 'Компенсатор высоты для УЭРМ-100-200 LIGHT (2 шт/компл)',
						count: Math.ceil(count),
						desc: 'Составная часть для регулирования УЭРМ по высоте.',
						img: styles.imgKompLight100,
						imgSrc: imgKompLight100
					});
				}
				else if (['2600-2800', '3200-3400', '3800-4000'].indexOf(uerm.height.toString()) >= 0)
				{
					uerm.acc.push({
						article: 'IND-KOMP-200-400-1-L',
						name: 'Компенсатор высоты для УЭРМ-200-400 LIGHT (2 шт/компл)',
						count: Math.ceil(count),
						desc: 'Составная часть для регулирования УЭРМ по высоте.',
						img: styles.imgKompLight200,
						imgSrc: imgKompLight200
					});
				}
				else if (['2800-3000', '3400-3600', '4000-4200'].indexOf(uerm.height.toString()) >= 0)
				{
					uerm.acc.push({
						article: 'IND-KOMP-400-600-1-L',
						name: 'Компенсатор высоты для УЭРМ-400-600 LIGHT (2 шт/компл)',
						count: Math.ceil(count),
						desc: 'Составная часть для регулирования УЭРМ по высоте.',
						img: styles.imgKompLight400,
						imgSrc: imgKompLight400
					});
				}

				if (['2400', '2500-2600', '2600-2800', '2800-3000'].indexOf(uerm.height.toString()) >= 0)
				{
					uerm.acc.push({
						article: 'IND-KET-KCC-1-0600-L',
						name: 'Короб верхний КЭТ/КСС-600 LIGHT (2 шт/компл)',
						count: Math.ceil(count),
						desc: 'Универсальный короб верхний высотой 600 мм, подходит и для КСС и КЭТ, является их продолжением сверху.',
						img: styles.imgKetKssLight600,
						imgSrc: imgKetKssLight600
					});
				}
				else if (['3000', '3100-3200', '3200-3400', '3400-3600'].indexOf(uerm.height.toString()) >= 0)
				{
					uerm.acc.push({
						article: 'IND-KET-KCC-1-1200-L',
						name: 'Короб верхний КЭТ/КСС-1200 LIGHT (2 шт/компл)',
						count: Math.ceil(count),
						desc: 'Универсальный короб верхний высотой 1200 мм, подходит и для КСС и КЭТ, является их продолжением сверху.',
						img: styles.imgKetKssLight1200,
						imgSrc: imgKetKssLight1200
					});
				}
				else if (['3600', '3700-3800', '3800-4000', '4000-4200'].indexOf(uerm.height.toString()) >= 0)
				{
					uerm.acc.push({
						article: 'IND-KET-KCC-1-1800-L',
						name: 'Короб верхний КЭТ/КСС-1800 LIGHT (2 шт/компл)',
						count: Math.ceil(count),
						desc: 'Универсальный короб верхний высотой 1800 мм, подходит и для КСС и КЭТ, является их продолжением сверху.',
						img: styles.imgKetKssLight1800,
						imgSrc: imgKetKssLight1800
					});
				}
			}
		}

		let specList = isUermLight ? this.state.specListLight.slice() : this.state.specList.slice();
		specList[num - 1] = uerm;
     this.doAddToCart(specList)
		if (isUermLight)
		{
			this.setState({
				specListLight: specList
			});
		}
		else
		{
			this.setState({
				specList
			});
		}
	}

	/**
	 * Показать соотв. аксессуар при смене свойств УЭРМ
	 */
	onUermPropChange(num, name, value) {
		let uermList = this.isUermLight() ? this.state.uermListLight.slice() : this.state.uermList.slice();
		uermList[num - 1][name] = value;

		let curAcc = null;
		switch (name)
		{
			case 'kvCnt':
			case 'yaurType':
				if (value === 'din') {
					curAcc = {
						name: 'Корпус металлический ЯУ-290-300 36 УХЛ3 IP31',
						desc: 'Корпус металлический предназначен для учета и распределения электроэнергии.',
						img: this.isUermLight() ? styles.imgMkmLight : styles.imgMkm
					};
				}
				if(value === 'mp') {
					curAcc = {
						name: `Ящик учетно-распределительный 'ЯУР-3/12'`,
						desc: 'Ящик учетно-распределительный (ЯУР) предназначен для учета и распределения электроэнергии.',
						img: this.isUermLight() ? styles.imgYaurLight : styles.imgYaur
					};
				}
				if(value === 'yhlz') {
					curAcc = {
						name: `Ящик учетно-распределительный ЯУР-380-300`,
						desc: 'Ящик учетно-распределительный (ЯУР) предназначен для учета и распределения электроэнергии.',
						img:  this.isUermLight() ? styles.imgYaurLightNew : styles.imgYaurNew
					};
				}
				break;

			case 'ket':
				curAcc = {
					name: 'Короб КЭТ',
					desc: 'Составной элемент УЭРМ, в котором располагается силовое оборудование и кабели.',
					img: styles.imgKet
				};
				break;

			case 'kss':
				curAcc = {
					name: 'Короб КCC',
					desc: 'Для размещения устройств слаботочных сетей (теле- и радиосетей, телефонных линий, домофонов) и оборудования автоматической системы контроля и учета электропотребления (АСКУЭ).',
					img: styles.imgKss
				};
				break;

			case 'ketTran':
				curAcc = {
					name: 'Короб КЭТ Транзит',
					desc: 'Составной элемент УЭРМ, в котором располагается силовое оборудование и кабели.',
					img: styles.imgKet
				};
				break;

			case 'kssTran':
				curAcc = {
					name: 'Короб КCC Транзит',
					desc: 'Для размещения устройств слаботочных сетей (теле- и радиосетей, телефонных линий, домофонов) и оборудования автоматической системы контроля и учета электропотребления (АСКУЭ).',
					img: styles.imgKss
				};
				break;
		}

		if (this.isUermLight())
		{
			this.setState({uermListLight: uermList, curAcc});
		}
		else
		{
			this.setState({uermList, curAcc});
		}
	}

	/*onDwgDownload() {
		window.location = `itkcfg.php?type=uerm&action=getDwg&article=uerm`;
	}*/
	onBtnAutoCADDownload() {
		window.location = `http://iek.ru/products/standard_solutions/download/IEK_autocad_2D.zip`;
	}
	onBtnNanoCADDownload() {
		window.location = `http://iek.ru/products/standard_solutions/download/iek-shkafy-kommutacionnye-apparaty-i-asip.rar`;
	}
	onBtnRevitDownload() {
		window.location = `http://iek.ru/products/standard_solutions/download/shkafy-i-boksy-iek-revit.zip`;
	}

	on3DDownload() {
		const type = this.isUermLight() ? '_light' : '';
		window.location = `itkcfg.php?type=uerm&action=getFile&name=3d${type}.zip`;
	}
	onPDFDownload() {
		const type = this.isUermLight() ? '_light' : '';
		window.location = `itkcfg.php?type=uerm&action=getFile&name=selection_table_UERM${type}.pdf`;
	}


	doPrint(params) {
		let _params = params || {};

		_params.data = {
			speclist: JSON.stringify(this.isUermLight() ? this.state.specListLight : this.state.specList)
		};

		super.doPrint(_params);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}

	onSpecRowClick(uermNum, accNum) {
		if (this.isUermLight())
		{
			this.setState({
				curAcc: this.state.specListLight[uermNum].acc[accNum]
			});
		}
		else
		{
			this.setState({
				curAcc: this.state.specList[uermNum].acc[accNum]
			});
		}
	}


	render() {
		if (!this.db) {
			return <div className={styles.cfg} />;
		}

		const isUermLight = this.isUermLight();

		const uermList = isUermLight ? this.state.uermListLight : this.state.uermList;
		const specList = isUermLight ? this.state.specListLight : this.state.specList;
		const curAcc = this.state.curAcc;

		return (
			<div className={styles.cfg}>
				<div className={styles.title}>Конфигуратор УЭРМ</div>

				<div className={styles.uermType}>
					<label>
						<input type="radio" name="uermType" value="" defaultChecked={true} onChange={this.onChangeUermType} />
						УЭРМ
					</label>
					<label>
						<input type="radio" name="uermType" value="light" onChange={this.onChangeUermType} />
						УЭРМ LIGHT
					</label>
				</div>

				<div className={styles.uermList}>
					{uermList.map((uerm, i) =>
						<UermCalc
							key={this.state.uermType + i}
							uerm={uerm}
							num={i + 1}
							isUermLight={isUermLight}
							onDelete={this.onDeleteUerm}
							onSpecAdd={this.onSpecAdd}
							onPropChange={this.onUermPropChange}
						/>
					)}

					<div className={styles.uermAddWrap}>
						<div className={styles.uermAdd} onClick={this.onAddUerm} />
					</div>
				</div>

				<SpecList specList={specList} curAcc={curAcc} onRowClick={this.onSpecRowClick} />

				<div className={styles.uermAccName}>{curAcc ? curAcc.name : (isUermLight ? 'УЭРМ LIGHT' : 'УЭРМ')}</div>
				<div className={curAcc && curAcc.img ? curAcc.img : (isUermLight ? styles.imgUermLight : styles.imgUerm)} />

				<div className={styles.uermAccDesc}>{curAcc ? curAcc.desc : ''}</div>

				{specList.length === 0 &&
				<div className={styles.uermDesc}>
					<div className={styles.uermDescTitle}>Описание УЭРМ</div>
					Корпус устройства этажного распределительного модульного УЭРМ используется для изготовления на его основе
					УЭРМ. В свою очередь УЭРМ предназначено для приема, учета и распределения электроэнергии в сетях 400/230 В, а
					также размещения устройств слаботочных сетей (теле- и радиосетей, телефонных линий, домофонов и т.п.) и
					оборудования автоматической системы контроля и учета электропотребления (АСКУЭ).
					<br/><br/>
					Корпус УЭРМ представляет собой сборно-разборную конструкцию, состоящую из отдельных элементов: короба
					электротехнического (КЭТ), в котором прокладывается силовой кабель, короба связи и сигнализации (КСС), ящиков
					учета и распределения (ЯУР), а также компенсаторов для возможности регулировки по высоте. Количество ЯУР
					эквивалентно количеству квартир на площадке.
				</div>
				}
				<div className={styles.onPDFDownload} onClick={this.onPDFDownload}>
					<span>Таблица подбора УЭРМ {isUermLight ? 'light': ''}</span>
				</div>
				<div className={styles.btnShowScheme} onClick={this.onShowScheme} />
				<div className={styles.btnPdf} onClick={this.onBtnPrintPdfClick} />
				<div className={this.state.showScheme ? (isUermLight ? styles.schemeLightVisible : styles.schemeVisible) : (isUermLight ? styles.schemeLight : styles.scheme)}>
					<div className={styles.uermCalcDelete} onClick={this.onCloseScheme} />
				</div>

				{/*<div className={styles.btnDwg} onClick={this.onDwgDownload} />*/}
				<a className={styles.btnAutoCAD} href={"http://iek.ru/products/standard_solutions/download/IEK_autocad_2D.zip"} target={"_blank"} rel={"nofollow noopener"}/>
				<a className={styles.btnNanoCAD} href={'http://iek.ru/products/standard_solutions/download/iek-shkafy-kommutacionnye-apparaty-i-asip.rar'} target={"_blank"} rel={"nofollow noopener"}/>
				<div className={styles.btn3D} onClick={this.on3DDownload} />

				<a className={styles.btnRevit} href={"http://iek.ru/products/standard_solutions/download/shkafy-i-boksy-iek-revit.zip"} target={"_blank"} rel={"nofollow noopener"}/>
				<div className={styles.btnExcel} onClick={this.onBtnExcelClick} />
				<div className={styles.btnPrint} onClick={this.onBtnPrintClick} />


				{/* На основной сайт IEK */}

				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '22px', top: '723px'}}/>
				<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#ffc93a',
					width: '50%',
					height: '22px',
					top: '723px',
					left: '513px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '726px',
					left: '250px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>
			</div>
		);
	}
}

class UermCalc extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showAddition: false
		}
	}

	render() {
		const uerm = this.props.uerm;
		const num = this.props.num; // количество УЭРМ
		const isUermLight = this.props.isUermLight // какая вкладка сейчас включена
		const height = this.props.isUermLight ? [2400, '2500-2600', '2600-2800', '2800-3000', 3000, '3100-3200',
			'3200-3400', '3400-3600', 3600, '3700-3800', '3800-4000', '4000-4200'] : [2500, 2600, 2700, 2800, 2850, 2950, 3300, 3850];

		return (
			<div className={styles.uermCalc}>
				<div className={styles.uermCalcTitle}>Расчет конструкции УЭРМ № {num}</div>
				{num > 1 && <div className={styles.uermCalcDelete} onClick={() => this.props.onDelete(num)} />}

				<select className={styles.uermCalcUermHeight} onChange={e => this.props.onPropChange(num, 'height', e.target.value)} defaultValue={uerm.height}>
					<option value="0">Высота УЭРМ, мм</option>
					{height.map(h => <option key={h} value={h}>{h}</option>)}
				</select>

				<select className={styles.uermCalcFlatCount} onChange={e => this.props.onPropChange(num, 'kvCnt', e.target.value)} defaultValue={uerm.kvCnt}>
					<option value="0">Количество квартир</option>
					{[...Array(20)].map((x, i) => <option value={i + 1} key={i}>{i + 1}</option>)}
				</select>
				<span className={styles.uermCalcYaurTitle}>ТИП ЯУР:</span>

				<label className={styles.uermCalcYaurTypeMp}>
					<input type="radio" name={`yaurType${num}`} value="mp" defaultChecked={uerm.yaurType === 'mp'}
								 onClick={() => this.props.onPropChange(num, 'yaurType', 'mp')} /> На монтажной панели (ЯУР 580x300x150мм)</label>

				<label className={styles.uermCalcYaurTypeYhlz}>
					<input type="radio" name={`yaurType${num}`} value="mp" defaultChecked={uerm.yaurType === 'yhlz'}
								 onClick={() => this.props.onPropChange(num, 'yaurType', 'yhlz')} />На DIN-рейке<br/> (ЯУР 385x300x150мм)</label>

				<label className={styles.uermCalcYaurTypeDin}>
					<input type="radio" name={`yaurType${num}`} value="din" defaultChecked={uerm.yaurType === 'din'}
								 onClick={() => this.props.onPropChange(num, 'yaurType', 'din')} /> На DIN-рейке<br/>(ЯУ 290х300х150мм)</label>

				<span className={styles.uermCalcKetTitle}>КОРОБ КЭТ:</span>
				<select className={styles.uermCalcKet} onChange={e => this.props.onPropChange(num, 'ket', e.target.value)} defaultValue={uerm.ket}>
					<option value="0">Не использовать</option>
					<option value="1">1</option>
					<option value="2">2</option>
					<option value="3">3</option>
					<option value="4">4</option>
					<option value="5">5</option>
				</select>

				<span className={styles.uermCalcKssTitle}>КОРОБ КСС:</span>
				<select className={styles.uermCalcKss} onChange={e => this.props.onPropChange(num, 'kss', e.target.value)} defaultValue={uerm.kss}>
					<option value="0">Не использовать</option>
					<option value="1">1</option>
					<option value="2">2</option>
					<option value="3">3</option>
					<option value="4">4</option>
					<option value="5">5</option>
				</select>

				{!isUermLight && <React.Fragment>
					<span className={styles.uermCalcKetTranTitle}>КОРОБ КЭТ ТРАНЗИТ:</span>
					<span className={styles.additionLeft}
								onPointerEnter={() => this.setState({showAddition: true})}
								onPointerLeave={() => this.setState({showAddition: false})}>&#63;</span>
					{this.state.showAddition
					&& <span className={styles.showAddition}>Короб транзитный КЭТ/КСС включает в себя противопожарную перегородку, отсутствуют боковые выбивные отверстия</span>}

					<select className={styles.uermCalcKetTran} onChange={e => this.props.onPropChange(num, 'ketTran', e.target.value)} defaultValue={uerm.ket}>
						<option value="0">Не использовать</option>
						<option value="1">1</option>
						<option value="2">2</option>
						<option value="3">3</option>
						<option value="4">4</option>
						<option value="5">5</option>
					</select>
					<span className={styles.uermCalcKssTranTitle}>КОРОБ КСС ТРАНЗИТ:</span>
					<span className={styles.additionRight}
								onPointerEnter={() => this.setState({showAddition: true})}
								onPointerLeave={() => this.setState({showAddition: false})}>&#63;</span>
					<select className={styles.uermCalcKssTran} onChange={e => this.props.onPropChange(num, 'kssTran', e.target.value)} defaultValue={uerm.kss}>
						<option value="0">Не использовать</option>
						<option value="1">1</option>
						<option value="2">2</option>
						<option value="3">3</option>
						<option value="4">4</option>
						<option value="5">5</option>
					</select>
				</React.Fragment>
				}


				<select className={styles.uermCalcUermCount} onChange={e => this.props.onPropChange(num, 'count', e.target.value)} defaultValue={uerm.count}>
					<option value="0">Количество УЭРМ № {num}</option>
					{[...Array(50)].map((x, i) =>
						<option value={i + 1} key={i}>{i + 1}</option>
					)}
				</select>

				<div className={styles.uermCalcAdd} onClick={() => this.props.onSpecAdd(num)} />
			</div>
		);
	}
}

class SpecList extends React.Component {
	render() {
		const specList = this.props.specList;
		const curAcc   = this.props.curAcc;

		let rowNum = 1;

		return (
			<div className={styles.specList}>
				{specList.map((x, i) => {
					rowNum++;

					return (
						<div key={i}>
							<div className={`${styles.specListTitle} ${rowNum % 2 === 0 ? styles.specListRowOdd : styles.specListRowEven}`}>
								УЭРМ {i + 1}
								<span className={styles.specListTitleCount}>{x.count}</span>
							</div>

							{x.acc.map((acc, j) => {
								rowNum++;
								const accSelected = curAcc && curAcc.article && (curAcc.article === acc.article);

								return (
									<div key={j} className={`${rowNum % 2 === 0 ? styles.specListRowOdd : styles.specListRowEven} ${accSelected ? styles.specListRowSelected : ''}`} onClick={() => this.props.onRowClick(i, j)}>
										<div className={styles.specListCellArticle}><a href={"https://www.iek.ru/products/catalog/?page=detail&article=" + acc.article} target={"_blank"} rel={"nofollow noopener"}>{acc.article}</a></div>
										<div className={styles.specListCellName}>{acc.name}</div>
										<div className={styles.specListCellCount}>{acc.count}</div>
									</div>
								)
							})}
						</div>
					)
				})}
			</div>
		);
	}
}

export default UermConfigurator;



// WEBPACK FOOTER //
// ./src/react/UermConfigurator.jsx